import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  standalone: true,
  selector: 'email-webhook-plan-downgraded-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './webhook-plan-downgraded.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    MailgunMarkAsHtmlPipe,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class WebhookPlanDowngradedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<WebhookPlanDowngradedTemplateData>;
}

export type WebhookPlanDowngradedTemplateData = {
  title: string;
  description: string;
  body_p1: string;
  go_to_billing_text: string;
  go_to_billing_link: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const WebhookPlanDowngradedTemplateMocks: WebhookPlanDowngradedTemplateData[] = [
  {
    title: '5 webhooks disabled',
    description: 'Company account was downgraded to the Launch plan.',
    body_p1:
      "Your company account's plan has been changed from <b>X</b> to <b>Launch</b>. Your new plan doesn't support webhooks.",
    go_to_billing_text: 'Go to billing page',
    go_to_billing_link: 'https://app.s.recruitee.com/#/settings/pricing/billing',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
  },
];
